import Vue from 'vue'

const mutations = {
  fights: (state, fights) => {
    return Vue.set(
      state,
      'fights',
      fights
    )
  },

  currentFight: (state, figth) => {
    return Vue.set(
      state,
      'currentFight',
      figth
    )
  },

  // Substitui o placar anterior: o painel do juiz de round recarrega depois de cada
  // correção, e acumular faria a tela continuar lendo o primeiro placar da lista.
  infoJudgesScoresFight: (state, scores) => {
    const fight = state.currentFight.filter(obj => !('firstJudge' in obj))
    fight.push(scores)
    return Vue.set(
      state,
      'currentFight',
      fight
    )
  },

  currentKeys: (state, keys) => {
    return Vue.set(
      state,
      'currentKeys',
      keys
    )
  },

  keysCategoryId: (state, id) => {
    return Vue.set(
      state,
      'keysCategoryId',
      id
    )
  }
}

export default mutations
